const paintProps = (opacity, fillColor) => {
  return {
    'fill-color': fillColor,
    'fill-outline-color': 'white',
    'fill-opacity': Number(opacity),
  };
};

export default paintProps;
